import { useNavigate } from 'react-router-dom';
import { Helpers } from '../../../utils/helpers';
import useUserSearch from './useUserSearch';
import { UserLookup } from '../../../components/user/UserLookup/UserLookup';
import { UserEditor } from '../UserEditor/UserEditor';
import Container from '../../../components/ui/Container/Container';

export const UserSearch = () => {
  const navigate = useNavigate();
  const manager = useUserSearch();
  return (
    <>
      <Container visible={Helpers.isNullOrWhiteSpace(manager.userId)}>
        <div className="page-container mt-2">
          <div className="text-end">
            <button className="btn btn-primary" onClick={() => navigate(`/users/enable-login`)}>
              Add New User
            </button>
          </div>
          <UserLookup
            showInactiveFilter={true}
            userId={manager.userId}
            onChange={manager.userSelected}
          />
        </div>
      </Container>
      <UserEditor userId={manager.userId} />
    </>
  );
};
